import { render, staticRenderFns } from "./SummaryCustomerNameModal.vue?vue&type=template&id=48b4287a"
import script from "./SummaryCustomerNameModal.vue?vue&type=script&lang=js"
export * from "./SummaryCustomerNameModal.vue?vue&type=script&lang=js"
import style0 from "./SummaryCustomerNameModal.vue?vue&type=style&index=0&id=48b4287a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports